import { BrowserRouter, Navigate, useLocation, Routes, Route } from "react-router-dom";
import MySidebar from "../components/Sidebar";
import Header from "../components/Header";
import RouteRenderer from "./RenderRoute";
import routes from "./routes";

const AppRouter = () => {
  const location = useLocation();
  const notFound = routes.find((item)=> item.path === location.pathname )
  // const isLoginPage = location.pathname === "/login" 
  const isAuthPage = location.pathname === "/login" || location.pathname === "/forgot-password";

  const showSideBar = ()=>{
    // if(isLoginPage) return false
      if (isAuthPage) return false; 
    if(!notFound) return false
    return true
  }

  return (
    <div className="flex h-screen">
    {showSideBar() && <MySidebar />}
    <div className="flex flex-col flex-1 overflow-hidden">
      {showSideBar() && <Header />}
      <Routes>
        <Route path="/*" element={<RouteRenderer />} />
      </Routes>
    </div>
  </div>
  );
};

export default AppRouter;